var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damage-part-content" }, [
    _c(
      "div",
      {
        staticClass: "damage-part",
        class: [{ buttonDeleteIsVisible: _vm.showDeleteBtn }],
      },
      [
        _c("p", { staticClass: "name-part" }, [
          _vm._v(_vm._s(_vm.damagedPart.literal)),
        ]),
        _c("p", { staticClass: "text-small mg mg--b-2" }, [
          _vm._v(_vm._s(_vm.$t("multidamageList.cameraFlow.textCamera"))),
        ]),
        _vm._l(_vm.damagedPart.partDamages, function (damage, i) {
          return _vm.damagedPart.partDamages != null
            ? _c(
                "ul",
                { key: i },
                [
                  i === 0
                    ? _c("div", { staticClass: "camera__damages" }, [
                        _c(
                          "div",
                          { staticClass: "damage__photos" },
                          _vm._l(damage.images, function (images) {
                            return _c("figure", { staticClass: "damage-img" }, [
                              _c("img", { attrs: { src: images } }),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm.flowName === "damage_billma_agent_new" ||
                  _vm.flowName === "e2e_new"
                    ? _c("maDamageItemCamera", {
                        attrs: { damage: damage },
                        on: {
                          deleteDamage: function ($event) {
                            return _vm.$emit("deleteDamage", i)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.flowName === "photoclaim"
                    ? _c("maDamageItemPhotoclaim", {
                        attrs: { damage: damage },
                        on: {
                          "option:edit": function ($event) {
                            return _vm.$emit("option:edit", i)
                          },
                          "option:delete": function ($event) {
                            return _vm.$emit("option:delete", i)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e()
        }),
        _vm.cameraBtn
          ? _c("div", { staticClass: "container-btn-add-element-camera" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { disabled: !_vm.buttonEnable },
                  on: { click: _vm.handleOnShowModalCamera },
                },
                [
                  _c("svgicon", {
                    attrs: {
                      name: "camera-create",
                      color: "#005BA5",
                      height: "15",
                      width: "auto",
                    },
                  }),
                  _c("p", { staticClass: "text-medium" }, [
                    _vm._v(
                      _vm._s(_vm.$t("multidamageList.cameraFlow.cameraBtn2"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "btn buttonLink",
                  attrs: { disabled: !_vm.buttonEnable },
                  on: { click: _vm.handleNoPhotosRequired },
                },
                [
                  _c("p", { staticClass: "text-medium black" }, [
                    _vm._v(
                      _vm._s(_vm.$t("multidamageList.cameraFlow.noRequired"))
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm.damagedPart.partDamages != undefined &&
        _vm.cameraBtn === false &&
        _vm.flowName !== "photoclaim"
          ? _c("div", { staticClass: "container-btn-add-element-camera" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { disabled: !_vm.buttonEnable },
                  on: { click: _vm.handleAddMoreDamage },
                },
                [
                  _c("svgicon", {
                    attrs: {
                      name: "camera-create",
                      color: "#005BA5",
                      height: "15",
                      width: "auto",
                    },
                  }),
                  _c("p", { staticClass: "text-medium" }, [
                    _vm._v(_vm._s(_vm.$t("actions.addMoreDamage"))),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }